<div class="p-5 d-flex flex-column justify-content-center align-items-center h-100">
  <div class="img-logo d-flex align-items-center ps-2 logo-animated mb-4">
    <img src="/assets/img/orbis/Logo_PRINCIPAL.png" height="100" alt="">
  </div>


  <div  class="text-center w-100">
    <div class="text-center mt-2">
    <h2 class="mt-3">{{'forgotPassword2' | translate}}</h2>
    <p>{{'forgotPasswordDesc' | translate}}</p>


    </div>
    <div class="mt-3">
      <input class="input_element" type="email" id="email" placeholder="Introduce tu email" [(ngModel)]="email">
    </div>

    <div class="d-flex flex-column align-items-center w-100">
      <div class="mt-2 w-100 d-flex justify-content-center">
        <button class="social-btn email-btn btn-primary" (click)="captchaRef.execute();"> {{'next' | translate}}</button>
      </div>
      <div class="mt-3  d-flex justify-content-between   ">
        <span class="link-style me-5 ps" (click)="navigateToLogin()">← {{'return' | translate}}</span>
      </div>
    </div>

  </div>


</div>
